import SolutionsModal from "./SolutionsModal";

export default SolutionsModal;
